import { Component, OnInit } from '@angular/core';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit
{
  public selectedTab = 0;

  constructor(private storageService: LocalStorageService)
  {
  }

  public ngOnInit(): void
  {
    const tabIndex = this.storageService.retrieve('test-selected-tab');
    if (tabIndex !== null && tabIndex !== undefined && tabIndex >= 0)
    {
      this.selectedTab = tabIndex;
    }
  }

  public onTabSelect(e: SelectEvent): void
  {
    this.selectedTab = e.index;
    this.storageService.store('test-selected-tab', this.selectedTab);
  }
}
